module.exports = __webpack_public_path__ + "media/images/seo/brand-0f0a57543bb14dff4584bbaa5a101df3623041724c7db8ba6beab737dd25caae.jpg";